const SONS = ['Yahya Nur Cabrasan', 'Fharhan Cabrasan'];
const BLOCK_SELECTOR = '[data-sumaira-sons="true"]';

const PARENT_NAMES = {
  bride: ['Mr. Jackeron Cabrasan', 'Mrs. Hatima Cabrasan'],
  groom: ['Mr. Emiliano Ponce Sr.', 'Mrs. Xochitl Ponce'],
};

function replaceNames(list, names) {
  if (!list) return;

  const currentItems = Array.from(list.children);
  const alreadyUpdated = currentItems.length === names.length
    && currentItems.every((item, index) => item.textContent.trim() === names[index]);

  if (alreadyUpdated) return;

  const items = names.map((name) => {
    const item = document.createElement('li');
    item.textContent = name;
    return item;
  });

  list.replaceChildren(...items);
}

function createSonsBlock() {
  const block = document.createElement('div');
  block.className = 'se-divider-title';
  block.dataset.sumairaSons = 'true';
  block.setAttribute('aria-label', 'Together with Our Beloved Sons');

  const caption = document.createElement('p');
  caption.className = 'se-panel-label';
  caption.textContent = 'Together with Our Beloved Sons';

  const names = document.createElement('ul');
  names.className = 'se-name-list';

  SONS.forEach((name) => {
    const item = document.createElement('li');
    item.textContent = name;
    names.appendChild(item);
  });

  block.append(caption, names);
  return block;
}

function ensureSonsBlock() {
  const entourage = document.querySelector('#se-entourage');
  if (!entourage || entourage.querySelector(BLOCK_SELECTOR)) return;

  const parentGrid = entourage.querySelector('.se-parent-grid');
  if (!parentGrid) return;

  parentGrid.insertAdjacentElement('afterend', createSonsBlock());
}

function updateInvitationParents() {
  const panels = document.querySelectorAll('#se-entourage .se-parent-grid .se-panel');

  panels.forEach((panel) => {
    const title = panel.querySelector('.se-panel-label')?.textContent.trim().toLowerCase() || '';
    const list = panel.querySelector('.se-name-list');

    if (title === 'parents of the bride') replaceNames(list, PARENT_NAMES.bride);
    if (title === 'parents of the groom') replaceNames(list, PARENT_NAMES.groom);
  });
}

function updatePrintableParents() {
  const panels = document.querySelectorAll('.sep-name-panel');

  panels.forEach((panel) => {
    const title = panel.querySelector('h3')?.textContent.trim().toLowerCase() || '';
    const list = panel.querySelector('ul');

    if (title === 'parents of the bride') replaceNames(list, PARENT_NAMES.bride);
    if (title === 'parents of the groom') replaceNames(list, PARENT_NAMES.groom);
  });
}

function applySumairaEntourageUpdates() {
  ensureSonsBlock();
  updateInvitationParents();
  updatePrintableParents();
}

if (typeof document !== 'undefined') {
  const start = () => {
    applySumairaEntourageUpdates();

    const observer = new MutationObserver(applySumairaEntourageUpdates);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}
